document.addEventListener('DOMContentLoaded', () => {
    console.log('start');

    let swSchemes = document.querySelectorAll('.swScheme');
    let userTheme = localStorage.getItem('toggleState') == 'on';

    if (userTheme) {
        document.body.classList.add('dark-theme');
    }

    swSchemes.forEach(swScheme => {
        if (swScheme) {
            swScheme.checked = userTheme
            swScheme.addEventListener('change', function () {
                if (swScheme.checked) {
                    document.body.classList.add('dark-theme');
                } else {
                    document.body.classList.remove('dark-theme');
                }

                localStorage.setItem('toggleState', swScheme.checked ? 'on' : 'off');
            })
        } else {
            console.error('Element with class .swScheme not found');
        }
    });

    function showTime() {
        try {
            let now = new Date();
            let date = now.toDateString();
            let time = now.toTimeString().split(' ')[0];

            let dateElements = document.querySelectorAll(".clock .date");
            let timeElements = document.querySelectorAll(".clock .time");

            dateElements.forEach(el => el.innerHTML = date);
            timeElements.forEach(el => el.innerHTML = 'GMT ' + time);
        } catch (e) {
            console.error(e);
        }
    }

    window.setInterval(showTime, 1000);

    const elements = [
        document.querySelector('.mobile-menu'),
        document.querySelector('.mobile-menu .bar'),
        document.querySelector('aside')
    ];

    document.querySelector('.mobile-menu').addEventListener('click', () => animateAction(elements, 'toggle'));
    window.addEventListener('resize', () => animateAction(elements, 'remove'));

    function animateAction(elements, action) {
        elements.forEach(el => toggleClass(el, 'animate', action));
    }

    function toggleClass(element, className, action) {
        if (action === 'toggle') {
            element.classList.toggle(className);
        } else if (action === 'remove') {
            element.classList.remove(className);
        }
    }
});